require('jquery-ui.1.11.1/ui/core');
require('jquery-ui.1.11.1/ui/widget');
require('jquery-ui.1.11.1/ui/mouse');
require('jquery-ui-touch-punch/jquery.ui.touch-punch.min');
require('jquery-ui.1.11.1/ui/draggable');
require('jquery-ui.1.11.1/ui/resizable');
require('./files/description');
require('./files/add-to-cart-personalized');
require('./files/personalized-product-text');
require('./files/reviews');
require('./files/review-images');
require('./files/modal-font');
require('./files/review-images-carousel');

require('../../css/web/add-to-cart.css');
require('../../css/web/reviews.css');
require('../../sass/web/reviews-images.scss');
require('../../css/web/tabs.css');
require('../../css/web/services.css');
require('../../css/web/personalized-text.css');
require('../../sass/web/personalized_services.scss');
require('../../sass/web/_modal-font.scss');
require('../../sass/web/review.scss');